var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70918 18.3984C1.08006 19.0312 0 18.5857 0 17.6934V2.01176C0 1.45853 0.195833 0.984927 0.5875 0.590956C0.979167 0.196985 1.45 0 2 0H18C18.55 0 19.0208 0.196985 19.4125 0.590956C19.8042 0.984927 20 1.45853 20 2.01176V14.0824C20 14.6356 19.8042 15.1092 19.4125 15.5032C19.0208 15.8971 18.55 16.0941 18 16.0941H4.41593C4.1497 16.0941 3.89446 16.2003 3.70676 16.3891L1.70918 18.3984Z",
    fill: "#172B4D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3.01746,
    width: 2,
    height: 6.03529,
    rx: 0.2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11.0643,
    width: 2,
    height: 2.01176,
    rx: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon1);
export default __webpack_public_path__ + "static/media/helpIcon1.514c09ad227ffaf9f275da2bd5f58f87.svg";
export { ForwardRef as ReactComponent };